import { PlaylistApiService } from './playlist-api.service';
import { PitchPlaylistService } from '../shared/pitch-playlist/state';
import { Injectable } from '@angular/core';
import { transaction } from '@datorama/akita';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PitchService {
  constructor(private api: PlaylistApiService, private playlists: PitchPlaylistService) {}

  @transaction()
  fetchAll(): Observable<any> {
    this.playlists.setLoading(true);

    return this.api.fetchAll({}).pipe(
      tap(response => {
        console.log(response);

        if (response) {
          if (response.expired) {
            this.playlists.pitchExpired();
          }

          this.playlists.updatePager(response);
          this.playlists.setPitch(response);
          this.playlists.setSongs(response);
        } else {
          this.playlists.pitchNotFound();
        }

        this.playlists.setLoading(false);
      })
    );
  }
}
